const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.new-product-card',
};

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
});

document.addEventListener('shopify-wishlist:updated', () => {
  initGrid();
});

window.addEventListener('load', () => {
  updateWishlistCount();
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
    .then((response) => response.text())
    .then((text) => {
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, 'text/html');
      const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
      if (!productCard) {
        console.warn(
          `[Shopify Wishlist] Product card not found for handle: ${handle}. The product may have been removed.`
        );
        return { handle, html: '' };
      }
      return { handle, html: productCard.outerHTML };
    })
    .catch((error) => {
      console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, error);
      return { handle, html: '' };
    });
};

const updateWishlistCount = () => {
  const element = document.querySelector('.wishlist__count');
  if (element) {
    const count = getWishlist().length;
    // Left empty at zero so .cart-count-bubble:empty hides the bubble.
    element.textContent = count > 99 ? '99+' : count || '';
  }
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);

  const staleHandles = responses.filter((result) => result.html === '').map((result) => result.handle);
  if (staleHandles.length > 0) {
    const cleanedWishlist = wishlist.filter((handle) => !staleHandles.includes(handle));
    setWishlist(cleanedWishlist);
    updateWishlistCount();
  }

  const validCards = responses.filter((result) => result.html !== '').map((result) => result.html);

  if (validCards.length > 0) {
    grid.innerHTML = validCards.join('');
    grid.classList.add(GRID_LOADED_CLASS);
    initButtons();

    // Update lazyload for new images
    if (window.lazyLoadInstance) {
      window.lazyLoadInstance.update();
    }
  } else {
    grid.innerHTML =
      "<div><h4>Wishlist is empty.</h4><p>You don't have any products in the wishlist yet.</p><p> You will find a lot of interesting products on our 'Store' page.</p><a class='btn' href='/collections/all'>Return To Store</a></div>";
  }

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: getWishlist() },
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle)
      return console.error(
        '[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.'
      );
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    button.addEventListener('click', () => {
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
      updateWishlistCount();
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() },
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array },
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};

// Make initButtons globally available for reinitialization
window.initWishlistButtons = initButtons;
